import type { StaticPage } from "~/types/Data/InformativePages/pages";

const staticPages: StaticPage[] = [
  { key: "home", title: "Home Page", url: "/" },
  { key: "contact-us", title: "Contact Us", url: "/contact-us" },
  { key: "about-us", title: "About Us", url: "/about-us" },
  {
    key: "terms-and-conditions",
    title: "Terms & Conditions",
    url: "/terms-and-conditions",
  },
  { key: "privacy-policy", title: "Privacy Policy", url: "/privacy-policy" },
  { key: "shipping-policy", title: "Shipping Policy", url: "/shipping-policy" },
  { key: "refund-policy", title: "Refund Policy", url: "/refund-policy" },
  { key: "faqs", title: "FAQs", url: "/FAQs" },
];

export default defineNuxtPlugin(() => ({
  provide: {
    staticPages,
  },
}));
